export class QuotationRequestModel {
    email: string;
    name: string;
    mobile: string;
    location: string;
    sellType: string;
    partnerId: string;
    lrsDeclarationRequestList: LrsDeclaration[] = new Array<LrsDeclaration>();
    nostroChargeType: string;
    quotationSnapshotId: string;
    pan: string;
    countryCode: string;
    appId: string;
    cardName: string;
    wsfxMargin: number;
    agentMargin: number;
    tcsPaymentSource: string;
    tcsPaymentSourceDetails: string;
    financialInstitution: string;
    quotationCurrencies: QuotationCurrenciesRequestModel[] =
    new Array<QuotationCurrenciesRequestModel>();
    ad1BankType: any;
    ad1BankName: any;
}

export class LrsDeclaration {
    pan: string;
    lrsDeclarationAmount: number;
    instituteName: string;
    transactionDate: Date;
}

export class QuotationCurrenciesRequestModel {
    currencyCode: string;
    rate: number;
    bidRate: number;
    currencyAmount: number;
    product: string;
    purpose: string;
    sellType: string;
    serviceCharges: any;
    nostroCharges: any;
    wsfxMargin: number;
    agentMargin: number;
    QuotationCurrenciesRequestModel: any;
    nostroCode: any;
    subPurpose: any;
}



// WEBPACK FOOTER //
// ./src/app/_models/quotation/QuotationRequestModel.ts